import { render, staticRenderFns } from "./ColorSlider.vue?vue&type=template&id=427f6484&scoped=true&"
import script from "./ColorSlider.vue?vue&type=script&lang=js&"
export * from "./ColorSlider.vue?vue&type=script&lang=js&"
import style0 from "./ColorSlider.vue?vue&type=style&index=0&id=427f6484&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427f6484",
  null
  
)

export default component.exports